import styled from 'styled-components';
import { BLUE } from 'govuk-colours';
import { SPACING, FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES } from '@govuk-react/constants';
import { spacing } from '@govuk-react/lib';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _styled$withConfig;
/**
 * Component showing related content, including topics, guidance and collections.
 *
 * - https://govuk-react.github.io/govuk-react/?path=/docs/related-items
 * - https://components.publishing.service.gov.uk/component-guide/related_navigation
 */

var RelatedItems = styled('div').withConfig({
  displayName: "src__RelatedItems",
  componentId: "sc-dvwdy9-0"
})((_styled$withConfig = {
  borderTop: "10px solid ".concat(BLUE),
  paddingTop: SPACING.SCALE_1,
  width: '100%'
}, _defineProperty(_styled$withConfig, MEDIA_QUERIES.LARGESCREEN, {
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16
}), _defineProperty(_styled$withConfig, '> h3', {
  marginBottom: SPACING.SCALE_2
}), _defineProperty(_styled$withConfig, '> ul', {
  marginBottom: SPACING.SCALE_4,
  '> li': {
    marginBottom: "calc(".concat(SPACING.SCALE_2, " + 2px)")
  }
}), _styled$withConfig), spacing.withWhiteSpace({
  marginBottom: 0
}));
RelatedItems.displayName = 'RelatedItems';

export { RelatedItems, RelatedItems as default };
